<div [ngClass]="{
  'extended-select-item--padding-bottom' : paddingBottom
}">
    <div class="extended-select-item__main-title">{{item.name}}</div>
    <div class="extended-select-item__content text-grey">
        <span *ngIf="showEngineCapacity">{{item.engineCapacity}} cm3 /</span>
        <span> {{item.kilowatts}} kW /</span>
        <span> {{item.horsepower}} KM /</span>
        <span> {{item.numberOfDoors}} {{'VEHICLE_VERSION_COMPONENT.doors' | translate}} /</span>
        <span> {{item.bodyType}} </span>
    </div>
</div>
